exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2n4kvOoWr4fi67kFigg17g {\n  border-top-left-radius: borderRadius;\n  border-bottom-left-radius: borderRadius;\n  border-bottom: 1px solid grey40;\n  border-left-width: 8px;\n  border-left-style: solid;\n  border-left-color: #415B6A;\n  background: white;\n  overflow: hidden;\n  padding: 8px;\n  text-align: left;\n  position: relative;\n  border-radius: 6px;\n  margin-left: 15px;\n  margin-right: 15px;\n  margin-bottom: 8px;\n}\n._2g9UKS-ldDL187nPXWKOfy {\n  margin-bottom: 8px;\n}\n._78UIy5wnlIydoZdno4ncs {\n  margin: 0;\n}\n\n._1LCHjxivLm4ojHk8MJ6Yna {\n  margin: 0;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.yUmwihqcM-kFidkSz4AHO {\n  position: absolute;\n  top: 0;\n  right: 0;\n  background: #d2d2d2;\n  height: 28px;\n  width: 28px;\n  border-radius: 4px;\n}\n._3EIAj8GtqvW-8OkJSIYdf0{\n  color: #878787;\n  font-size: 12px;\n  margin-top: -6px;\n  font-size: 14px;\n  font-weight: 100\n}\n", ""]);

// exports
exports.locals = {
	"interpretation": "_2n4kvOoWr4fi67kFigg17g",
	"date": "_2g9UKS-ldDL187nPXWKOfy",
	"interpretationTitle": "_78UIy5wnlIydoZdno4ncs",
	"interpretationPause": "_1LCHjxivLm4ojHk8MJ6Yna",
	"loadingWrapper": "yUmwihqcM-kFidkSz4AHO",
	"qtValueCss": "_3EIAj8GtqvW-8OkJSIYdf0"
};


//////////////////
// WEBPACK FOOTER
// /builds/alivecorbackend/kardia-pro/node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!/builds/alivecorbackend/kardia-pro/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/components/IDTFRecordingInfoPane/Interpretation/Interpretation.css
// module id = 10621
// module chunks = 25